const isString = string => {
    return !!string;
};

export const isNum = num => {
    const numChange = parseInt(num);
    return typeof numChange === "number" && numChange <= 251 && numChange >= 2;
};

export const nameValidation = [
    {
        isValid: isString,
        errorMsg: "Please enter a team name. "
    }
];

export const numValidation = [
    {
        isValid: isNum,
        errorMsg: "Must choose between 2 to 251 members."
    }
];
